import { Checkbox as ReshapedCheckbox } from '@zinc/ui';
import { useId } from 'react';

export interface IProps extends CheckboxProps {
  disabled?: boolean;
  label?: React.ReactNode;
  value?: string;
}

const Checkbox: React.FC<IProps> = ({ disabled, label, value, onChange, ...other }) => {
  const id = useId();

  return (
    <ReshapedCheckbox
      name={id}
      disabled={disabled}
      value={value}
      className="p-2"
      {...other}
      onChange={({ event }) => {
        onChange(event);
      }}
    >
      {label}
    </ReshapedCheckbox>
  );
};

export default Checkbox;
